const baseAppURL = process.env.REACT_APP_BASE_URL;
export class LetterHead {
    static imageUrl = baseAppURL + 'images/LetterHeade1.png';
    static linkTags = [
        'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css',
        baseAppURL + 'main.css',
        'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@1,400&display=swap',
        'https://fonts.googleapis.com/css?family=Montserrat&display=swap'
    ];
    static letterheadStyle = `
    @media print {
        .header, .footer {
            width: 100%;
            position: fixed;
            background-color: #f5f5f5;
            // padding: 10px; /* You can remove or reduce this */
        }
        .header {
            top: 0;
        }
        .footer {
            bottom: 0;
            padding: 0; 
            margin: 0; 
            height: 30px;
        }
        .footer-space {
            height: 30px; 
        }
        .header-space {
            height: 130px;
        }
        .content {
            width:100%;
            page-break-inside: avoid !important; 
        }
        .header-img-left{
            width: 170px;
            margin-left: 0px;
            height:120px;
        }
        .footer-img-left{
            width: 300px;
            font-size:10px;
            margin-left: 0; 
            padding-left: 0; 
            margin-top:7px;
        }
        .header-right {
            width: 200px;
            position: absolute;
            right: 0px;
            top: 20px;
            padding: 0;
            margin: 0;
        }
        .footer-img-right{
            width:150px;
            position:absolute;
            right:0; 
            bottom: 0; 
        }
        .footer-second-list{
            position:absolute;
            left:250px;
            bottom: 0; 
            margin: 0; 
            padding: 0; 
        }
        li::marker{
            color:#006D9E;
            font-size:12px;
             bottom: 0; 
            margin: 0;
            padding: 0; 
        }
        li{
            color:gray;
            font-size: 10px;
            margin: 0;
            padding: 0;
            line-height: 1em;
            list-style-position: inside;
        }
        .table-main{
            width:100%
        }
    }
`;
    static header = `<div class="header"><img class="header-img-left" src="${LetterHead.imageUrl}" />
<div class="header-right">
<ul>
<li>Benjamin Franklinstraat 27</li>
<li>8013 NC Zwolle</li>
<li> Tel. (038) 447 88 22</li>
<li>Fax (038) 460 05 47</li>
<li>info@vissemederland.nl</li>
<li>www.vissemederland.nl</li>
</ul>
</div>
</div>`;
    static footerImageUrl = baseAppURL + 'images/Footer2.png';
    static footer = `<div class="footer">
<div class="footer-img-left">
<ul>
<li>IBAN: NL80 RABO 0396 5152 15</li>
<li>BIC: RABONL2U</li>
</ul>
</ul>
    <ul class="footer-second-list">
    <li>BTW-nr NL/802007879 B01</li>
    <li>K.v.K. Zwolle 08058532</li>
    </ul>
</div>
<img class="footer-img-right" src="${LetterHead.footerImageUrl}" /></div>`;
}
